module.exports = Object.freeze({
  ///role
  DI_ADMIN: "ROLE_DI_ADMIN",
  ROLE_ADMIN: "ROLE_ADMIN",
  ROLE_LAB: "ROLE_LAB",
  SUPER_ADNIM: "SUPER_ADMIN",
  BLOGGER: "ROLE_BLOGGER",
  ROLEDOCTOR: "ROLE_DOCTOR",
  ROLE_USER: "ROLE_USER",
  ROLE_X_RAYX: "ROLE_X-RAY",

  ////

  DROPDOWNSARCHYNAME: "dropDownSearchByName",

  SERCH_TEMPLATE_BY_CAT_ID_AVD_TEMPNAME: "searchTemplateByCatIdAndTempName",

  // Employee End Points
  ADD_EMPLOYEE: "addEmployee",

  GENERATE_REPORT: "generateReport",
  GET_ALL_EMPLOYEE: "getAllEmployee",
  GET_ALL_EMPLOYEE_BY_BRANCH_ID: "getAllEmployeeByBranchId",
  GET_DAILY_ATTENDENCE: "getDailyAttendances",
  ADD_SHIFT: "addShifts",
  GET_ALL_SHIFT: "getAllShift",
  ADD_DEPARTMENT: "addDepartment",
  GET_ALL_DEPARTMENT: "getAllDepartment",
  MARK_ATTENDANCE: "markAttendance",
  BUNCH_MARK_ATTENDANCE: "bunchMarkAttendance",
  SEARCH_EMPLOYEE_BY_NAME: "searchEmployeeByName",
  SEARCH_EMPLOYEE_BY_ID: "searchEmployeeByID",
  ACTIVE_STATUS_SHIFT: "activeStatusShift",

  ADDNEWDATAFORALL: "addNewDataForAll",
  GETALLTEMPLATENAME: "getAllTemplateName",
  GETTEMPLATEBYCATIDANDTEMID: "getTemplateByCatIdAndTempId",
  GET_ROOT_TEMPLATE: "getRootTemplate",
  GET_DATA_BYNAME_MOBILE: "getDataByNameOrMobileNos",

  ADDMEDICINE: "addMedicine",

  ADD_MEDICENE: "addMedicine",
  ITEM_STATUS_CHANGE: "itemStatusChange",
  SEARCH_ALL_MASTER_BY_PAGINATION: "searchAllMasterByPagination",
  getDataByNameOrMobileNo: "getDataByNameOrMobileNo",
  getLabTestDataByToken: "getLabTestDataByToken",
  deleteLabTestRecord: "deleteLabTestRecord",
  saveLabTestRecord: "saveLabTestRecord",
  uploadFileToDrive: "uploadFileToDrive",
  getLabTestTokensByDateRange: "getLabTestTokensByDateRange",
  // Constant for Google Drive URLs
  GOOGLE_DRIVE_PREVIEW_URL: "https://drive.google.com/file/d/{fileId}/view",
  GOOGLE_DRIVE_DOWNLOAD_URL:
    "https://drive.google.com/uc?export=download&id={fileId}",

  ///  color
  visitBackgroundColor: "#f5f5f5", // Background color for visit
  visitPadBackgroundSecondary: "#ffffff", // Secondary background color for visit pad
  allVisitPadBackground: "#d0d5dd", // Background color for all visit pads
  tableBackgroundHeader: "#eaecf5", // Background color for table header
  iconColor: "#667085", // Color for icons

  // Employee
  ADD_EMPLOYEE_ON_BOARD: "addEmployeeOnboard",

  //di admin

  GRT_HOSPITA_BY_NAME_ID: "getHospitalsByNameOrId",
  CREACTHOSPITAL: "createHospital",
  GET_ALL_HOSPITAL_BY_STATUS: "getAllHospitalsByStatus",
  STATUSCHANGEBYHOSPITALTD: "statusChangeByHospitalId",

  // Branch
  AAD_HOSPITAL_BRANCH: "addHospitalBranch",
  GET_ALL_HOSPITAL_BRANCH_BY_STATUS: "getAllHospitalsBranchByStatus",
  STATUS_CHANGE_BY_BRANCH_ID: "statusChangeByBranchId",
  GET_HOSPITAL_BY_NAME: "getHospitalsByName",

  GET_ALL_DEPARTME_BY_BRANCH_ID: "getAllDepartmentByBranchId",
  GET_ALL_SHIFT_BY_BRANCH_ID: "getAllShiftByBranchId",

  SERCH_BRANCH_BY_NAME_WITH_PAGINATION:
    "searchBranchByNameAndHospitalIdWithPagination",

  /// Docoto Reg.

  SEARCH_DOCTOR_WITH_PAGINATIO: "searchDoctorByNameOrMobileNoWithPagination",
  ACTIVE_STATUSBYHOSPITAL_DOCOTOR_ID: "activeStatusByHospitalDoctorId",
  ADD_DOCTOR_ON_BOARD: "addDoctorOnboard",

  SERCH_DOCOTOR_BU_NAME_MOBAILNO: "searchDoctorByNameOrMobileNo",

  /// CustomerId

  FIND_BY_CUSTOMER_ID: "findByCustomerId",
});
